import backgroundSFX from "../../assets/audioL/backgroundSFX.mp3";
import cardFlipSFX from "../../assets/audioL/cardFlipSFX.mp3";
import holdSFX from "../../assets/audioL/holdSFX.mp3";
import dealSFX from "../../assets/audioL/dealSFX.mp3";
import playSFX from "../../assets/audioL/playSFX.mp3";
import cashoutSFX from "../../assets/audioL/cashoutSFX.mp3";
import goForwardSFX from "../../assets/audioL/goForwardSFX.mp3";
import pickSFX from "../../assets/audioL/pickSFX.mp3";
import gambleSFX from "../../assets/audioL/gambleSFX.mp3";

import loseSFX from "../../assets/audio/loseSFX.mp3";
import winSFX from "../../assets/audio/winSFX.mp3";

import useSound from "use-sound";

export default function useAudio(volume: string, sound: boolean) {
  let vol = parseFloat(volume);
  const [playCardFlipSFX] = useSound(cardFlipSFX, {
    volume: vol,
  });
  const [playHoldSFX] = useSound(holdSFX, {
    volume: vol,
  });
  const [playDealSFX] = useSound(dealSFX, {
    volume: vol,
  });
  const [playGambleSFX] = useSound(gambleSFX, {
    volume: vol,
  });
  const [playPlaySFX] = useSound(playSFX, {
    volume: vol,
  });
  const [playCashoutSFX] = useSound(cashoutSFX, {
    volume: vol,
  });
  const [playWinSFX] = useSound(winSFX, {
    volume: vol,
  });
  const [playLoseSFX] = useSound(loseSFX, {
    volume: vol,
  });
  const [playGoForwardSFX] = useSound(goForwardSFX, {
    volume: vol,
  });
  const [playPickSFX] = useSound(pickSFX, {
    volume: vol,
  });

  const LOCALAUDIO = {
    cardFlip: () => sound && playCardFlipSFX(),
    hold: () => sound && playHoldSFX(),
    deal: () => sound && playDealSFX(),
    play: () => sound && playPlaySFX(),
    cashout: () => sound && playCashoutSFX(),
    gamble: () => sound && playGambleSFX(),
    lose: () => sound && playLoseSFX(),
    win: () => sound && playWinSFX(),
    goForward: () => sound && playGoForwardSFX(),
    pick: () => sound && playPickSFX(),
    background: backgroundSFX,
    cardflip: cardFlipSFX,
  };
  return { LOCALAUDIO };
}
